var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "下载对账单明细",
        width: "900px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c("div", { staticClass: "merchant-card" }, [
        _c("div", { staticClass: "merchant-info" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家类型：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.merchantInfo.merchantTypeText || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家名称：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.merchantInfo.merchantName || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item info-item-full" }, [
            _c("span", { staticClass: "label" }, [_vm._v("对账周期：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.merchantInfo.periodDesc || "-") +
                  "\n        "
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.processingCount > 0
        ? _c("div", { staticClass: "export-notice" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(
              "\n    当前有 " +
                _vm._s(_vm.processingCount) +
                " 个任务正在处理中，页面每5秒自动刷新\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "history-section" },
        [
          _c("div", { staticClass: "section-header" }, [
            _c(
              "div",
              { staticClass: "section-title" },
              [
                _c("span", { staticClass: "title-text" }, [
                  _vm._v("下载历史记录"),
                ]),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "对账只能以【导出最新对账单明细】为准",
                      placement: "top",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-question",
                      staticStyle: { cursor: "pointer", color: "#909399" },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "section-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", icon: "el-icon-refresh" },
                    on: { click: _vm.fetchList },
                  },
                  [_vm._v("刷新列表数据")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "warning",
                      icon: "el-icon-download",
                      loading: _vm.exporting,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleExport(2)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          导出已结算售后订单：" +
                        _vm._s(_vm.settledAfterSaleOrderCount) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-download",
                      loading: _vm.exporting,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleExport()
                      },
                    },
                  },
                  [_vm._v("\n          导出最新对账单明细\n        ")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "record-table",
              attrs: {
                data: _vm.list,
                size: "small",
                stripe: "",
                border: "",
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#606266",
                  fontWeight: "bold",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "operateUser",
                  label: "操作人",
                  width: "120",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "导出时间",
                  width: "170",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDateTime(scope.row.createTime)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "completeTime",
                  label: "完成时间",
                  width: "170",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "time-success": scope.row.status === "COMPLETED",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.completeTime
                                    ? _vm.formatDateTime(scope.row.completeTime)
                                    : "-"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fileName",
                  label: "文件名",
                  "min-width": "220",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.fileName
                          ? [
                              _c("div", { staticClass: "file-cell" }, [
                                _c("i", {
                                  staticClass: "el-icon-document excel-icon",
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "file-name",
                                    attrs: { title: scope.row.fileName },
                                  },
                                  [_vm._v(_vm._s(scope.row.fileName))]
                                ),
                              ]),
                            ]
                          : _c("span", { staticClass: "file-empty" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "导出状态",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTagType(scope.row.status),
                              size: "small",
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.statusText(scope.row.status)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === "COMPLETED"
                          ? [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "下载文件",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        icon: "el-icon-download",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleFileDownload(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("下载")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.pagination.total > 0
            ? _c("el-pagination", {
                staticClass: "pagination",
                attrs: {
                  "current-page": _vm.pagination.page,
                  "page-sizes": [10, 20, 50],
                  "page-size": _vm.pagination.limit,
                  total: _vm.pagination.total,
                  layout: "total, sizes, prev, pager, next",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.listLoading && _vm.list.length === 0
            ? _c("div", { staticClass: "empty-state" }, [
                _c("i", { staticClass: "el-icon-folder-opened empty-icon" }),
                _vm._v(" "),
                _c("p", { staticClass: "empty-text" }, [
                  _vm._v("暂无导出记录"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "empty-hint" }, [
                  _vm._v("点击上方「导出最新对账单明细」按钮生成导出文件"),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "400px",
            title: "确认导出",
            visible: _vm.confirmVisible,
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "confirm-content" }, [
            _c("i", { staticClass: "el-icon-warning warning-icon" }),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.exportDetailType === 2
                    ? "确定要导出已结算售后订单吗？"
                    : "确定要导出账单明细订单吗？"
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "confirm-sub" }, [
              _vm._v(
                _vm._s(
                  _vm.exportDetailType === 2
                    ? "将导出当前对账单下的已结算售后订单，生成Excel文件"
                    : "将导出当前对账单下的所有订单数据，生成Excel文件"
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.confirmVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.exporting },
                  on: { click: _vm.doExport },
                },
                [_vm._v("确定导出")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.exportDialogVisible,
            title: _vm.exportDialogTitle,
            "show-close": true,
            "close-on-click-modal": true,
            "append-to-body": "",
            "destroy-on-close": "",
            "custom-class": "export-dialog",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "export-dialog-content" }, [
            _vm.isInQueue
              ? _c("div", { staticClass: "queue-mode" }, [
                  _c("div", { staticClass: "queue-icon-wrapper" }, [
                    _c("i", { staticClass: "el-icon-refresh queue-icon" }),
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "export-title queue-title" }, [
                    _vm._v("您已进入排队队列"),
                  ]),
                  _vm._v(" "),
                  _vm.currentQueuePosition > 0
                    ? _c("div", { staticClass: "queue-position" }, [
                        _vm._v("\n          当前排队位置：第 "),
                        _c("span", { staticClass: "queue-number" }, [
                          _vm._v(_vm._s(_vm.currentQueuePosition)),
                        ]),
                        _vm._v(" 位\n        "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.queueDetail
                    ? _c("div", { staticClass: "queue-detail-info" }, [
                        _vm.queueDetail.processingTask
                          ? _c("div", { staticClass: "detail-row" }, [
                              _c("span", { staticClass: "detail-label" }, [
                                _vm._v("正在执行："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "detail-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.queueDetail.processingTask.taskTypeName
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.queueDetail.processingTask.userName
                                ? _c("span", { staticClass: "detail-owner" }, [
                                    _c("i", { staticClass: "el-icon-user" }),
                                    _vm._v(
                                      _vm._s(
                                        _vm.queueDetail.processingTask.userName
                                      ) + "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.queueDetail.processingTask.progress
                                ? _c(
                                    "span",
                                    { staticClass: "detail-progress" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.queueDetail.processingTask
                                              .progress
                                          ) +
                                          "%\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.queueDetail.waitingCount > 0
                          ? _c("div", { staticClass: "detail-row" }, [
                              _c("span", { staticClass: "detail-label" }, [
                                _vm._v("排队中："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "detail-value" }, [
                                _vm._v(
                                  _vm._s(_vm.queueDetail.waitingCount) +
                                    " 个任务"
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.queueDetail.processingTask &&
                        _vm.queueDetail.processingTask.estimatedRemainingSeconds
                          ? _c("div", { staticClass: "detail-row" }, [
                              _c("span", { staticClass: "detail-label" }, [
                                _vm._v("预计剩余："),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "detail-value detail-time" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatWaitTime(
                                        _vm.queueDetail.processingTask
                                          .estimatedRemainingSeconds
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "queue-waiting-hint" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _vm._v(
                      "\n          前方有导出任务正在执行，请耐心等待\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "queue-tip" }, [
                    _c("i", { staticClass: "el-icon-s-management" }),
                    _vm._v(
                      "\n          您可以关闭此窗口，前往「导出任务」查看具体排队情况\n        "
                    ),
                  ]),
                ])
              : _c("div", [
                  _c("i", { staticClass: "el-icon-download export-icon" }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "export-title" }, [
                    _vm._v("正在导出数据，请稍候..."),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "progress-container" },
                    [
                      _vm.exportProgress < 100
                        ? _c("el-progress", {
                            attrs: {
                              percentage: _vm.exportProgress,
                              "stroke-width": 20,
                              color: _vm.customColors,
                              "text-inside": true,
                            },
                          })
                        : _c("el-progress", {
                            attrs: {
                              percentage: 100,
                              "stroke-width": 20,
                              color: "#67C23A",
                              status: "success",
                              "text-inside": true,
                            },
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "progress-info" }, [
                        _c("span", { staticClass: "status-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.exportProgress < 100
                                ? "导出处理中..."
                                : "导出完成！"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "progress-text" }, [
                          _vm._v(_vm._s(_vm.exportProgress) + "%"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.exportProgress < 100
                    ? _c("div", { staticClass: "export-tip" }, [
                        _c("i", { staticClass: "el-icon-info" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "关闭弹窗后可在「导出任务」中查看进度和下载文件"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }